"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ADMIN_ROLE = 'ADMIN';
exports.CAREAPP_INTEGRATION_ROLE = 'CAREAPP_INTEGRATION';
exports.CAREAPP_SUPPORT_1 = 'CAREAPP_SUPPORT_1';
exports.CAREAPP_SUPPORT_2 = 'CAREAPP_SUPPORT_2';
exports.CAREAPP_MANAGER = 'CAREAPP_MANAGER';
exports.CARER_ROLE = 'CARER';
exports.CUSTOMER_CARER_ROLE = 'CUSTOMER_CARER';
exports.CUSTOMER_COORDINATOR_ROLE = 'CUSTOMER_COORDINATOR';
exports.CARER_COORDINATOR_ROLE = 'CARER_COORDINATOR';
exports.COORDINATOR_ROLE = 'COORDINATOR';
exports.FAMILY_ROLE = 'FAMILY';
exports.CUSTOMER_FAMILY_ROLE = 'CUSTOMER_FAMILY';
exports.CUSTOMER_FAMILY_REPRESENTATIVE_ROLE = 'CUSTOMER_FAMILY_REPRESENTATIVE';
exports.ORGANISATION_ADMIN_ROLE = 'ORG_ADMIN';
exports.TENANT_ADMINISTRATOR = 'TENANT_ADMINISTRATOR';
exports.CUSTOMER_MEMBER_ROLE = 'CUSTOMER_MEMBER';
exports.CUSTOMER_SELF_ROLE = 'CUSTOMER_SELF';
exports.GLOBAL_ROLES = [
    exports.ADMIN_ROLE,
    exports.CAREAPP_INTEGRATION_ROLE,
    exports.CAREAPP_SUPPORT_1,
    exports.CAREAPP_SUPPORT_2,
    exports.CAREAPP_MANAGER,
];
exports.TENANT_ROLE_HEIRARCHY = [exports.TENANT_ADMINISTRATOR];
exports.ORGANISATION_ROLE_HEIRARCHY = [
    exports.ADMIN_ROLE,
    exports.ORGANISATION_ADMIN_ROLE,
    exports.COORDINATOR_ROLE,
    exports.CARER_ROLE,
    exports.CUSTOMER_MEMBER_ROLE,
    exports.FAMILY_ROLE,
];
exports.DASHBOARD_ROLES = [exports.ADMIN_ROLE, exports.ORGANISATION_ADMIN_ROLE, exports.COORDINATOR_ROLE];
exports.STAFF_ROLES = [exports.ORGANISATION_ADMIN_ROLE, exports.COORDINATOR_ROLE, exports.CARER_ROLE];
exports.TENANT_ROLES = [exports.TENANT_ADMINISTRATOR];
exports.ORGANISATION_ROLES = [
    exports.ORGANISATION_ADMIN_ROLE,
    exports.COORDINATOR_ROLE,
    exports.CARER_ROLE,
    exports.CUSTOMER_MEMBER_ROLE,
    exports.FAMILY_ROLE,
];
exports.CARER_ROLES = [exports.CARER_COORDINATOR_ROLE];
exports.CUSTOMER_ROLES = [
    exports.CUSTOMER_COORDINATOR_ROLE,
    exports.CUSTOMER_CARER_ROLE,
    exports.CUSTOMER_SELF_ROLE,
    exports.CUSTOMER_FAMILY_ROLE,
    exports.CUSTOMER_FAMILY_REPRESENTATIVE_ROLE,
];
exports.ROLES = Array.from(new Set(exports.GLOBAL_ROLES.concat(exports.TENANT_ROLES, exports.ORGANISATION_ROLES, exports.CARER_ROLES, exports.CUSTOMER_ROLES)));
exports.CUSTOMER_ROLE_HERIRARCHY = [
    exports.ADMIN_ROLE,
    exports.ORGANISATION_ADMIN_ROLE,
    exports.CUSTOMER_COORDINATOR_ROLE,
    exports.COORDINATOR_ROLE,
    exports.CUSTOMER_CARER_ROLE,
    exports.CARER_ROLE,
    exports.CUSTOMER_SELF_ROLE,
    exports.CUSTOMER_FAMILY_REPRESENTATIVE_ROLE,
    exports.CUSTOMER_FAMILY_ROLE,
    exports.CUSTOMER_MEMBER_ROLE,
    exports.FAMILY_ROLE,
];
